import { render, staticRenderFns } from "./AmetrasPdfPageResizeWrapperTemplate.vue?vue&type=template&id=72a27464&"
import script from "./AmetrasPdfPageResizeWrapperTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasPdfPageResizeWrapperTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
